import { render, staticRenderFns } from "./FoldersTree.vue?vue&type=template&id=5b3bb120&scoped=true&"
import script from "./FoldersTree.vue?vue&type=script&lang=js&"
export * from "./FoldersTree.vue?vue&type=script&lang=js&"
import style0 from "./FoldersTree.vue?vue&type=style&index=0&id=5b3bb120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3bb120",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b3bb120')) {
      api.createRecord('5b3bb120', component.options)
    } else {
      api.reload('5b3bb120', component.options)
    }
    module.hot.accept("./FoldersTree.vue?vue&type=template&id=5b3bb120&scoped=true&", function () {
      api.rerender('5b3bb120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/components/FoldersTree.vue"
export default component.exports